import "@rails/actiontext"

import { Turbo } from "@hotwired/turbo-rails"
Turbo.session.drive = false

import TurboPower from 'turbo_power'
TurboPower.initialize(Turbo.StreamActions)

import "../controllers/index"
import "../initializers/rich_text_editor"
import "../initializers/turbo_custom_actions"
import "../initializers/third_party_widgets_cleanup"
import "../initializers/appsignal"
import * as ActiveStorage from "@rails/activestorage"

ActiveStorage.start()
